import React from 'react';
import VmDetailView from '../../../shared/components/evm/VmDetailView';
import evmService from '../../../shared/services/evmService';

const VmDetail = () => <VmDetailView mode="user" api={evmService} />;

export default VmDetail;
